import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import Downloader from "../../components/pdf_downloader/Downloader";

export default function Download(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Typography variant="h1" sx={{fontSize:`${fontSize+0.5}rem`, margin:"5px 0"}}>Download</Typography>
            <hr/>
            <Box sx={{borderLeft:"5px solid #0b4285", padding:"2px 0 2px 10px", marginTop:"20px", backgroundColor:"whitesmoke"}}>
                <Downloader url={"pdf/download/SocialAuditFormatMeghalaya_English.pdf"} name={"[English] Format for Social Audit under Mahatma Gandhi National Rural Employee Garantee Act (MGNREGA)"}/> 
                <Downloader url={"pdf/download/SocialAuditFormatMeghalaya_Khasi.pdf"} name={"[Khasi] Format for Social Audit under Mahatma Gandhi National Rural Employee Garantee Act (MGNREGA) "}/> 
                <Downloader url={"pdf/download/SocialAuditFormatMeghalaya_Garo.pdf"} name={"[Garo] Format for Social Audit under Mahatma Gandhi National Rural Employee Garantee Act (MGNREGA)"}/> 
                <Downloader url={"pdf/download/FormatIAY2015.pdf"} name={"[English] Format for Social Audit Under Indira Awaas Yojana (IAY) Scheme"}/> 
                <Downloader url={"pdf/download/Social_Audit_Act_2017.pdf"} name={"[English] The Meghalaya Community Participation and Public Services Social Audit Act, 2017"}/> 
            </Box>
        </Box>
    )
}